import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { Layout, Spinner } from "../../ui-kit";
import nsi from "../../store/nsi";
import dictionaryStore from "../../store/dictionary";
import { authStore } from "../../store/authStore";
import ResourceForm from "./resourceForm";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";

const DefectForm: React.FC = observer(() => {
  const { id, type } = useParams<{ id: string; type: string }>();
  const { userProfileIsLoading, resourceType } = authStore;

  const organizationId = localStorage.getItem("userOrgId");

  useEffect(() => {
    dictionaryStore.getDictionaryData("MkaEventType");
    dictionaryStore.getDictionaryData("MkaUtilitiesSector");
    dictionaryStore.getDictionaryData("MkaTechonologicalProcessStage");
    dictionaryStore.getDictionaryData("MkaObjectKind");
    dictionaryStore.getDictionaryData("MkaIncidentType");
    dictionaryStore.getDictionaryData("MkaDecisionStatus");
    dictionaryStore.getDictionaryData("AddressArea");
    // nsi.getGasSupplyObjects();
    nsi.getDefectReasons();
    nsi.getLightingProblemTypes();
    // nsi.getLightingObjects();
    nsi.getGridTypes();
    nsi.getIncidentStatuses();
    // nsi.getObjectEntities();
    nsi.getEventTypes();
    nsi.getGasketTypes();
    nsi.getComplaintCodes();
    nsi.getRepairCategories();
    nsi.getWorkStatus();
    nsi.getWorkProgresses();
    nsi.getActivityTypes();
    // nsi.getColdWaterSupplyObjects();
    nsi.getPipeTypes();
    nsi.getDefectExternalManifestation();
    // nsi.getHeatSupplyObjects();
    nsi.getProducedWorks();
    nsi.getWorkTypes();
    nsi.getDistricts();
    nsi.getRestrictionNatures();
    nsi.getOrganizations();
  }, []);

  useBreadcrumbs([
    { link: "/sp/reestr", name: "Ситуационное управление" },
    { link: "/sp/reestr", name: "Реестр дефектов" },
    { name: "Создание/редактирование дефекта" },
  ]);

  const isCloseType = type === "close"

  return (
    <Layout>
      {userProfileIsLoading.value ? (
        <Spinner />
      ) : (
        <ResourceForm
          resourceType={resourceType}
          defectId={+id}
          isClose={isCloseType}
          userId={organizationId}
        />
      )}
    </Layout>
  );
});

export default DefectForm;
